import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DiagnosisService } from '../../../employee-view/services/diagnosis.service';
import { map, filter, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-diagnosis-code',
    templateUrl: './diagnosis-code.component.html',
    styleUrls: ['./diagnosis-code.component.scss'],
    standalone: false
})
export class DiagnosisCodeComponent implements OnInit {
  searchChain: Array<{ name: string, current: boolean }>;
  optionArray: Array<{ value: number, text: string }>;

  searchBox = new UntypedFormControl();
  typeAhed$: Observable<any>;

  searchText: string;
  chapter: string;
  chapterId: number;
  group: string;
  groupId: number;
  threeDigitGroup: string;
  threeDigitGroupId: number;
  diagnosis: string;
  diagnosisCode: string;


  constructor(
    @Inject(MAT_DIALOG_DATA) public Tipo: any,
    public dialogRef: MatDialogRef<DiagnosisCodeComponent>,
    private diagnosisService: DiagnosisService) {
  }

  ngOnInit() {
    this.CreateSearchChain();

    this.typeAhed$ = this.searchBox.valueChanges.pipe(
      filter(text => {
        return text.length > 2;
      }),
      debounceTime(10),
      distinctUntilChanged(),
      switchMap((searhText: string) => {
        this.searchText = searhText;
        let api;
        switch (this.GetCurrentChainElement().name) {
          case 'Chapter':
            api = this.diagnosisService.SearchChapters(this.Tipo.Tipo, searhText).pipe(map(resp => resp.result));
            break;
          case 'Group':
            api = this.diagnosisService.SearchGroups(this.Tipo.Tipo, this.chapterId, this.searchText).pipe(map(resp => resp.result));
            break;
          case 'ThreeDigitGroup':
            api = this.diagnosisService.SearchThreeDigitGrops(this.Tipo.Tipo, this.groupId, this.searchText).pipe(map(resp => resp.result));
            break;
          case 'Diagnosis':
            api = this.diagnosisService.SearchDiagnosisCode(this.Tipo.Tipo, this.groupId, this.searchText).pipe(map(resp => resp.result));
            break;
        }
        return api;
      })
    );
  }

  public onClick(option) {
    if (this.GetCurrentChainElement().name === 'Chapter') {
      this.chapterId = option.id;
      this.chapter = option.descripcion;
    } else if (this.GetCurrentChainElement().name === 'Group') {
      this.groupId = option.grupo;
      this.group = option.descripcion;
    } else if (this.GetCurrentChainElement().name === 'ThreeDigitGroup') {
      this.threeDigitGroup = option.descripcion;
      this.threeDigitGroupId = option.id;
    } else {
      this.diagnosisCode = option.codigo;
      this.diagnosis = option.descripcion;
    }
    this.searchBox.setValue('');
    this.GoForward();
  }

  public onChipClose(opt) {
    switch (opt) {
      case 1:
        this.chapter = undefined;
        this.chapterId = undefined;
        break;
      case 2:
        this.group = undefined;
        this.groupId = undefined;
        break;
      case 3:
        this.threeDigitGroup = undefined;
        this.threeDigitGroupId = undefined;
        break;
      case 4:
        this.diagnosis = undefined;
        this.diagnosisCode = undefined;
        break;
    }
    this.GoBackWard();
  }

  private CreateSearchChain() {
    this.searchChain = [
      { name: 'Chapter', current: true },
      { name: 'Group', current: false },
      { name: 'ThreeDigitGroup', current: false },
      { name: 'Diagnosis', current: false }
    ];
  }

  public GetCurrentChainElement() {
    return this.searchChain.find(x => x.current === true);
  }

  private GoForward() {
    let currentIndex = this.searchChain.findIndex(x => x.current === true);
    this.searchChain[currentIndex].current = false;
    currentIndex = ((this.searchChain.length - 1) === currentIndex) ? currentIndex : (++currentIndex);
    this.searchChain[currentIndex].current = true;
  }

  private GoBackWard() {
    let currentIndex = this.searchChain.findIndex(x => x.current === true);
    this.searchChain[currentIndex].current = false;
    currentIndex = (currentIndex === 0) ? currentIndex : (--currentIndex);
    this.searchChain[currentIndex].current = true;
  }

  public AcceptCodes() {
    this.dialogRef.close(
      {
        'chapter': this.chapter,
        'chapterId': this.chapterId,
        'group': this.group,
        'groupId': this.groupId,
        'threeDigitGroup': this.threeDigitGroup,
        'threeDigitGroupId': this.threeDigitGroupId,
        'diagnosis': this.diagnosis,
        'diagnosisCode': this.diagnosisCode,
        'tipo': this.Tipo
      }
    );
  }

}
